@if (address(); as address) {
  <onyx-address [address]="address" format="extended"></onyx-address>
} @else {
  -
}
